export const loadSimmplifyScripts = () => {
    return new Promise(res => {
        try {
            const script = document.createElement('script');
            script.src = 'https://www.simplify.com/commerce/v1/simplify.js';
            script.async = true;
            script.onload = () => {
                const scriptPay = document.createElement('script');
                scriptPay.src = 'https://www.simplify.com/commerce/simplify.pay.js';
                scriptPay.async = true;
                document.body.appendChild(scriptPay);
                scriptPay.onload = () => {
                    res(true);
                }
            }
            document.body.appendChild(script);
        } catch (error) {
            console.error(error)
            res(false);
        }
    })
}